module.exports = __webpack_public_path__ + "../resources/images/letsgo-stars-a-863a76f0ab9aa48a398f25172865568a.png";